module.exports = __webpack_public_path__ + "img/programme4.4c383912.png";